import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { getOrderPrint, getOrderPrintPreviousOrders } from "../Helper/order";
import { processDetailHtml } from "../Helper/printHelper";
import "./BillStyles.css";

const PrintBill = () => {
  const [data, setData] = useState(null);
  const [detailHtml, setDetailHtml] = useState(null);
  const { Id } = useParams();
  const location = useLocation();

  useEffect(() => {
    const printMode = location.state?.printMode || "total";
    const targetId = Id || location.state?.printData?.orderId;
    
    if (targetId) {
      const fetchApi = printMode === "detail" 
        ? getOrderPrintPreviousOrders(targetId) 
        : getOrderPrint(targetId);

      fetchApi.then((res) => {
        if (res) {
          // Both APIs return HTML strings. Use the helper to unify styles.
          setDetailHtml(processDetailHtml(res, { hideQr: printMode === "total" }));
          setTimeout(() => {
            window.print();
          }, 1000);
        } else {
          setData(null);
        }
      }).catch(err => {
        console.error(`${printMode} API call failed:`, err);
        setData(null);
      });
    }
  }, [Id, location.state]);

  if (detailHtml) {
    return <div dangerouslySetInnerHTML={{ __html: detailHtml }} />;
  }

  if (!data && !detailHtml) {
    return <div>Loading...</div>;
  }

  return null;
};

export default PrintBill;
